import { IBlog } from "../../types/CommonTypes";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";

interface IProps {
	blog: IBlog;
	height?: string;
}

export default function BlogCard({ blog, height = "100%" }: IProps) {
	const navigate = useNavigate();

	const handleReadMore = () => {
		navigate(`/blog/${blog.slug}`, { state: { blog } });
	};

	return (
		<Box
			onClick={handleReadMore}
			component="img"
			src={blog.picture.url}
			alt={blog.title || ""}
			sx={{
				width: "100%",
				height: height,
				objectFit: "cover",
				cursor: "pointer",
				boxShadow: 3,
				borderRadius: 1,
				transition: "transform 0.5s ease",
				"&:hover": {
					transform: "scale(0.99)",
				},
			}}
		/>
	);
}
